import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2def82ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view add-group" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-group__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "add-group__title" }, "Add group")
], -1))
const _hoisted_3 = { class: "add-group__form-panel" }
const _hoisted_4 = { class: "add-group__form-section" }
const _hoisted_5 = { class: "add-group__form-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-group__headline" }, "Main Informations", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "add-group__text" }, "Provide all informations to add a group", -1))
const _hoisted_8 = { class: "add-group__input-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Group name", -1))
const _hoisted_10 = { class: "add-group__input-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Color", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-group__bot-buttons" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button--big button--green" }, "Add Group")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColorPicker = _resolveComponent("ColorPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newGroup.name) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.newGroup.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_ColorPicker, {
                modelValue: _ctx.newGroup.color,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newGroup.color) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_12
        ])
      ])
    ], 32)
  ]))
}